import type { AnalysisStatus } from "../../model/Analysis";
import { PREPARATION_STEPS } from "./PREPARATION_STEPS";

// Номер текущего шага для статуса подготовки.
export const stepIndexOf = (status: AnalysisStatus): number => {
  const pending = status === "waiting_for_match" ? "fetching_match" : status;
  return Math.max(
    0,
    PREPARATION_STEPS.findIndex((step) => step.status === pending),
  );
};
